import React, { useEffect, useState } from 'react';

const questions = [
  {
    title: "🎯 1000 - 247 = ?",
    drops: ["7", "5", "3"],
    layout: ["1", "0", "0", "0", "-", "2", "4", "7", "=", "drop", "drop", "drop"],
    options: ["7", "5", "3", "6", "9"]
  },
  {
    title: "🎯 1000 - 462 = ?",
    drops: ["8", "3", "5"],
    layout: ["1", "0", "0", "0", "-", "4", "6", "2", "=", "drop", "drop", "drop"],
    options: ["8", "3", "5", "2", "6"]
  },
  {
    title: "🎯 1000 - 319 = ?",
    drops: ["6", "8", "1"],
    layout: ["1", "0", "0", "0", "-", "3", "1", "9", "=", "drop", "drop", "drop"],
    options: ["6", "8", "1", "4", "7"]
  },
  {
    title: "🎯 10000 - 1284 = ?",
    drops: ["8", "7", "1", "6"],
    layout: ["1", "0", "0", "0", "0", "-", "1", "2", "8", "4", "=", "drop", "drop", "drop", "drop"],
    options: ["8", "7", "1", "6", "3", "9"]
  },
  {
    title: "🎯 10000 - 5092 = ?",
    drops: ["4", "9", "0", "8"],
    layout: ["1", "0", "0", "0", "0", "-", "5", "0", "9", "2", "=", "drop", "drop", "drop", "drop"],
    options: ["4", "9", "0", "8", "2"]
  },
  {
    title: "🎯 1000 - 123 = ?",
    drops: ["7", "7", "8"],
    layout: ["1", "0", "0", "0", "-", "1", "2", "3", "=", "drop", "drop", "drop"],
    options: ["7", "7", "8", "9", "6"]
  }
];

export default function SubtractingGame() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [userAnswers, setUserAnswers] = useState([]);
  const [result, setResult] = useState('');
  const [shuffledOptions, setShuffledOptions] = useState([]);

  const currentQuestion = questions[currentIndex];

  useEffect(() => {
    const shuffled = [...currentQuestion.options].sort(() => Math.random() - 0.5);
    setShuffledOptions(shuffled);
    setUserAnswers(Array(currentQuestion.drops.length).fill(null));
    setResult('');
  }, [currentIndex]);

  const handleDrop = (index, value) => {
    const updatedAnswers = [...userAnswers];
    updatedAnswers[index] = value;
    setUserAnswers(updatedAnswers);

    if (updatedAnswers.every(ans => ans !== null)) {
      const correct = updatedAnswers.every((ans, i) => ans === currentQuestion.drops[i]);
      setResult(correct ? '🎉 Great job!' : '❌ Try again!');
    }
  };

  const nextQuestion = () => {
    setCurrentIndex((prev) => (prev + 1) % questions.length);
  };

  const allowDrop = (e) => e.preventDefault();

  const handleDrag = (e, value) => {
    e.dataTransfer.setData('text', value);
  };

  const handleDropSlot = (e, index) => {
    e.preventDefault();
    const value = e.dataTransfer.getData('text');
    handleDrop(index, value);
  };

  const styles = {
    gameContainer: {
      fontFamily: 'Arial, sans-serif',
      textAlign: 'center',
      padding: 20,
      backgroundColor: '#f0f8ff',
      minHeight: '100vh'
    },
    dropZone: {
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      marginBottom: 20,
      gap: 10
    },
    dropSlot: {
      width: 50,
      height: 50,
      border: '2px dashed #aaa',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: 20,
      fontWeight: 'bold',
      backgroundColor: '#fff',
      borderRadius: 5,
      margin: '0 5px'
    },
    correct: {
      borderColor: 'green',
      backgroundColor: '#d0f0c0'
    },
    wrong: {
      borderColor: 'red',
      backgroundColor: '#ffcdd2'
    },
    dragZone: {
      display: 'flex',
      justifyContent: 'center',
      flexWrap: 'wrap',
      gap: 10,
      marginBottom: 20
    },
    draggable: {
      padding: '10px 15px',
      backgroundColor: '#2196f3',
      color: 'white',
      borderRadius: 5,
      cursor: 'grab',
      fontSize: 18,
      fontWeight: 'bold'
    },
    result: {
      fontSize: 24,
      marginTop: 10,
      fontWeight: 'bold',
      color: '#4caf50'
    },
    button: {
      marginTop: 15,
      padding: '10px 20px',
      fontSize: 16,
      borderRadius: 5,
      backgroundColor: '#4caf50',
      color: 'white',
      border: 'none',
      cursor: 'pointer'
    }
  };

  let dropIndex = 0;

  return (
    <div style={styles.gameContainer}>
      <h1>{currentQuestion.title}</h1>
      <div style={styles.dropZone}>
        {currentQuestion.layout.map((item, i) => {
          if (item === 'drop') {
            const userValue = userAnswers[dropIndex];
            const correct = currentQuestion.drops[dropIndex] === userValue;
            const slotStyle = {
              ...styles.dropSlot,
              ...(userValue ? (correct ? styles.correct : styles.wrong) : {})
            };
            const index = dropIndex;
            dropIndex++;
            return (
              <div
                key={i}
                style={slotStyle}
                onDragOver={allowDrop}
                onDrop={(e) => handleDropSlot(e, index)}
              >
                {userValue}
              </div>
            );
          }
          return (
            <span key={i} style={{ fontSize: 22, margin: '0 5px' }}>
              {item}
            </span>
          );
        })}
      </div>

      <div style={styles.dragZone}>
        {shuffledOptions.map((opt, i) => (
          <div
            key={i}
            style={styles.draggable}
            draggable
            onDragStart={(e) => handleDrag(e, opt)}
          >
            {opt}
          </div>
        ))}
      </div>

      <div style={styles.result}>{result}</div>
      <button style={styles.button} onClick={nextQuestion}>
        Next Question ➡️
      </button>
    </div>
  );
}
